// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "c3f2aca";
